import { SelectOption } from '@/components/Form/src/types'
import { completionApliicationEnum } from './BasicTrainingCompletionFormEnum'

const statusOption: SelectOption[] = [
  {
    label: 'Submitted',
    value: completionApliicationEnum.Status.Submitted
  },
  {
    label: 'Approved by Admin',
    value: completionApliicationEnum.Status.ApprovedbyAdmin
  },
  {
    label: 'Rejected by Admin',
    value: completionApliicationEnum.Status.RejectedbyAdmin
  }
]

export const basicTrainingCompletionOption = { statusOption }
